const Button = ({ children, active, disabled, ...props }: any) => (
  <span className={`button ${active ? 'active' : 'inactive'}`} disabled={disabled} {...props}>
    {children}
  </span>
)

Button.displayName = 'Button'

const Icon = ({ className, ...props }: any) => <span className={`icon ${className}`} {...props} />

Icon.displayName = 'Icon'

const Toolbar = ({ children }: any) => <div className="toolbar">{children}</div>

Toolbar.displayName = 'Toolbar'

export { Button, Icon, Toolbar }
